/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyJobListFilter {
    getFixupPrototypeFunction() { return PolicyJobListFilter.fixupPrototype; }

    static newInstance(model: Partial<PolicyJobListFilter>): PolicyJobListFilter {
        let obj = Object.assign(new PolicyJobListFilter(), model);
        PolicyJobListFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyJobListFilter>): PolicyJobListFilter {
        if (!model) return null;
        return PolicyJobListFilter.newInstance(<PolicyJobListFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyJobListFilter) {
        if (!obj) return;

        models.PolicyJobListFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyJobListFilter): boolean {
        Object.setPrototypeOf(obj, PolicyJobListFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.from_date === "string") {
            this.from_date = new Date(<string><any>this.from_date);
        }
        if (typeof this.to_date === "string") {
            this.to_date = new Date(<string><any>this.to_date);
        }
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
    }

    /**
     * Filter by status, execution_type, engine_type, policy_id, cloud_providers, service_account_ids, has_violations
     */
    filters: models.QueryOperator;

    /**
     * Search by job name, policy name, or service account name
     */
    search: string;

    /**
     * Filter jobs created on or after this date
     */
    from_date: Date;

    /**
     * Filter jobs created on or before this date
     */
    to_date: Date;

    /**
     * Set to true to list archived jobs. Defaults to false.
     */
    archived: boolean;

}
